import { DeviceGrantPolicy, DeviceSharingRequest } from '../types/devices';

export const isRequestNotExpired = (request: DeviceSharingRequest): boolean => {
  const expiresAtPolicy = request.policies?.find(
    (policy) => policy.device_grant_policy === DeviceGrantPolicy.EXPIRES_AT
  );

  if (!expiresAtPolicy) {
    return true;
  }

  const expiresAtTimestamp = Date.parse(
    expiresAtPolicy.device_grant_policy_value
  );

  if (Number.isNaN(expiresAtTimestamp)) {
    return true;
  }

  return expiresAtTimestamp >= Date.now();
};
